import { ACCESS_LOGINS } from '../constants/const'
import { menuStructure } from '../constants/menuStructure'


const checkAccess = (accessList, item, withShare, login) => item.access || accessList?.includes(item.title) || (withShare && item.title === 'Обмен файлами') || ACCESS_LOGINS.includes(login?.toLowerCase())

export const getActualMenuStructure = (accessList, withShare, login) => {
  return menuStructure
    .filter(item => !item.hidden)
    .map(item => ({
      ...item,
      access: checkAccess(accessList, item, withShare, login),
      dropdown: item.dropdown
        ?.filter(child => !child.hidden && checkAccess(accessList, child, withShare, login))
        .map(child => ({
          ...child,
          access: checkAccess(accessList, child, withShare, login),
        })),
    }))
    .filter(item => item.dropdown ? item.dropdown.length > 0 : item.access)
}

export const getActualRoutes = (accessList, login) => {
  return menuStructure
    .flatMap(item => [item, ...(item.dropdown ?? [])])
    .filter(item => item.component && checkAccess(accessList, item, true, login))
    .map(({ path, component }) => ({ path, component }))
}
